import { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import MainLayout from './components/MainLayout/MainLayout';
import store from './redux';
import { isAuthenticated } from './App';
import { signout } from './App';

export function getAccessToken() {
    return store.getState().auth.access_token
}

export function getIdToken() {
    return store.getState().auth.id_token
}

export function getApiController() {
    return store.getState().auth.apiController
}

export function getIdpRef(): any {
    return localStorage.getItem('idpRef');
}

function ProtectedRoute({ subRoute = false, component: Component, ...rest }) {
    //@ts-ignore
    const user = useSelector(state => state.auth.user)

    useEffect(() => {
        if (user) {
            if (user?.expired === true) {
                console.log(user?.expired)
                signout();
            }
        }
    }, [user?.expired])

    useEffect(() => {
        console.log('log when user change: ', user, isAuthenticated())
    }, [user])

    return isAuthenticated() && !user ? null :
        user && user.access_token ?
            subRoute ?
                <Route {...rest} component={Component} /> :
                <MainLayout>
                    <Route {...rest} component={Component} />
                </MainLayout>
            : <Redirect to={'/'} />
}

export default ProtectedRoute;
